import { render, staticRenderFns } from "./pointsfor.vue?vue&type=template&id=a1f4ff10&"
import script from "./pointsfor.vue?vue&type=script&lang=js&"
export * from "./pointsfor.vue?vue&type=script&lang=js&"
import style0 from "./pointsfor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports